import React from 'react';
import { MarketingPage } from './MarketingPage';
import manifest from './content/manifest.json';

// Eagerly import every converted page's HTML as a raw string.
const contents = import.meta.glob('./content/*.html', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

function htmlFor(name: string): string {
  return contents[`./content/${name}.html`] ?? '';
}

export interface MarketingRoute {
  path: string;
  element: React.ReactElement;
}

/** Public marketing routes, derived from the build-time content manifest. */
export const marketingRoutes: MarketingRoute[] = manifest.map((entry) => ({
  path: entry.route,
  element: (
    <MarketingPage html={htmlFor(entry.name)} title={entry.title} description={entry.description} />
  ),
}));
